import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import JobListing from "./JobListing";
import { useSelector } from "react-redux";
import SubscriptionPopup from "../../common/SubscribePopup";
import { useNavigate } from "react-router-dom";
import * as paths from "../../../constants/paths";

function PaginatedJobs({
  data,
  itemsPerPage,
  jobs,
  isSearching,
  saveJob,
  isJobSaving,
  isJobReporting,
  handleReportAnJob,
  handleShowSigninPopup,
  showSigninPopup,
  showReportPopup,
  handleToggleReportPopup,
  setPageNo,
  pageNo,
  totalJobs,
  is_global_val,
  noJobsPanel,
  insightPanel,
}) {
  const navigate = useNavigate();
  const authToken = useSelector((state) => state.fetchSignin.authToken);
  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [showSubscripitionPopup, setShowSubscriptionPopup] = useState(false);

  const plan = useSelector((state) => state.fetchSiteSettings.plan);
  const handleToggleSubscriptionPopup = () => {
    setShowSubscriptionPopup(!showSubscripitionPopup);
  };
  const initialPage = pageNo - 1;

  useEffect(() => {
    // const endOffset = itemOffset + itemsPerPage;
    // setCurrentItems(jobs.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(totalJobs / itemsPerPage));
  }, [totalJobs]);

  const handlePageClick = (event) => {
    // console.log(event.selected);
    window.scrollTo({ top: 300, behavior: "smooth" });
    let pageNumber = event.selected + 1;
    const isAlreadyInBasePath =
      typeof window !== "undefined" &&
      window.location.pathname.includes(`${paths.SITE_BASE_URL}`);
    const basePath = isAlreadyInBasePath ? "" : `${paths.SITE_BASE_URL}`;
    if (pageNumber > 2) {
      if (!plan) {
        navigate(basePath + "/subscription");
        // window.location.replace("/subscription");
        return false;
      } else {
        setPageNo(event.selected + 1);
        // navigate(`${basePath}/open-jobs/${event.selected + 1}`);

        const currentParams = new URLSearchParams(window.location.search);
        currentParams.set("pageNo", String(event.selected + 1));
        const queryString = currentParams.toString();
        navigate(
          `${basePath}/open-jobs/${event.selected + 1}${
            queryString ? `?${queryString}` : ""
          }`,
        );

        // const newOffset = (event.selected * itemsPerPage) % jobs.length;
        // setItemOffset(newOffset);
      }
    } else {
      setPageNo(event.selected + 1);
      // navigate(`${basePath}/open-jobs/${event.selected + 1}`);

      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set("pageNo", String(event.selected + 1));
      const queryString = currentParams.toString();
      navigate(
        `${basePath}/open-jobs/${event.selected + 1}${
          queryString ? `?${queryString}` : ""
        }`,
      );

      // const newOffset = (event.selected * itemsPerPage) % jobs.length;
      // setItemOffset(newOffset);
    }
  };

  return (
    <>
      <JobListing
        data={data}
        jobs={jobs}
        isSearching={isSearching}
        saveJob={saveJob}
        isJobSaving={isJobSaving}
        isJobReporting={isJobReporting}
        handleReportAnJob={handleReportAnJob}
        handleShowSigninPopup={handleShowSigninPopup}
        showSigninPopup={showSigninPopup}
        showReportPopup={showReportPopup}
        handleToggleReportPopup={handleToggleReportPopup}
        is_global_val={is_global_val}
        noJobsPanel={noJobsPanel}
        insightPanel={insightPanel}
      />
      <ReactPaginate
        forcePage={initialPage}
        breakLabel="..."
        nextLabel="next >"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel="< previous"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
        renderOnZeroPageCount={false}
      />
      {showSubscripitionPopup && (
        <SubscriptionPopup
          handleToggleSubscriptionPopup={handleToggleSubscriptionPopup}
        />
      )}
    </>
  );
}

export default PaginatedJobs;
